import { Injectable } from '@angular/core';
import { NgxZendeskWebwidgetService } from 'ngx-zendesk-webwidget';
import { MatDialog } from '@angular/material/dialog';
import { ModalContactUsComponent } from '@app/components/modals/modalContactUs/modalContactUs.component';

@Injectable({
  providedIn: 'root',
})
export class ZendeskService {
  private zendeskIsAvailable: boolean = false;

  constructor(
    private ngxZendeskWebwidgetService: NgxZendeskWebwidgetService,
    private dialog: MatDialog,
  ) {}

  public initZendesk(): void {
    this.ngxZendeskWebwidgetService.initZendesk();
  }

  public setUpZendeskForUser(fullName: string, email: string | undefined): void {
    if (this.ngxZendeskWebwidgetService && typeof this.ngxZendeskWebwidgetService.zE === 'function') {
      if (fullName && email) {
        this.ngxZendeskWebwidgetService.zE('webWidget', 'identify', {
          name: fullName,
          email: email,
        });

        this.ngxZendeskWebwidgetService.zE('webWidget', 'prefill', {
          name: {
            value: fullName,
            readOnly: true,
          },
          email: {
            value: email,
            readOnly: true,
          },
        });

        this.ngxZendeskWebwidgetService.zE('webWidget', 'show');
        this.zendeskIsAvailable = true;
      } else {
        this.ngxZendeskWebwidgetService.zE('webWidget', 'hide');
        this.zendeskIsAvailable = false;
      }
    }
  }

  public contactUs(): void {
    if (this.ngxZendeskWebwidgetService.isInitialized && this.zendeskIsAvailable) {
      this.ngxZendeskWebwidgetService.zE('webWidget', 'open');
    } else {
      this.dialog.open(ModalContactUsComponent);
    }
  }

  public hideWidget(): void {
    if (this.ngxZendeskWebwidgetService && typeof this.ngxZendeskWebwidgetService.zE === 'function') {
      this.ngxZendeskWebwidgetService.zE('webWidget', 'hide');
    }
  }

  public showWidget(): void {
    if (this.ngxZendeskWebwidgetService && typeof this.ngxZendeskWebwidgetService.zE === 'function') {
      this.ngxZendeskWebwidgetService.zE('webWidget', 'show');
    }
  }
}
